module.exports = __webpack_public_path__ + "static/media/icon-table-activity.b06364d6.svg";